//const serverPath = 'http://localhost/IPFF2/backend/public';
const serverPath = 'https://ipff2.bdprescription.com/ipff2_backend/public';
//const serverPath = 'http://10.42.140.218:8080/IPFF2/backend/public';
export default {serverPath}


// WEBPACK FOOTER //
// ./src/server-path/server-path.js